"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyWithISO = exports.getMoneyFormatLocale = exports.getCurrency = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const get_all_markets_1 = require("./get-all-markets");
const getCurrency = (brand, iso2) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    if (!supportedBrand) {
        return;
    }
    const market = get_all_markets_1.allMarkets[supportedBrand].find((m) => (0, basic_types_1.asIsoCountryCode2)(m.country.iso2) === (0, basic_types_1.asIsoCountryCode2)(iso2));
    return market === null || market === void 0 ? void 0 : market.country.currency;
};
exports.getCurrency = getCurrency;
const getMoneyFormatLocale = (brand, iso2) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    if (!supportedBrand) {
        return;
    }
    const market = get_all_markets_1.allMarkets[supportedBrand].find((m) => (0, basic_types_1.asIsoCountryCode2)(m.country.iso2) === (0, basic_types_1.asIsoCountryCode2)(iso2));
    return market === null || market === void 0 ? void 0 : market.country.moneyFormatLocale;
};
exports.getMoneyFormatLocale = getMoneyFormatLocale;
const getCurrencyWithISO = (iso2) => {
    try {
        if (iso2) {
            const brands = Object.keys(get_all_markets_1.allMarkets);
            let isCurrencyFound = false;
            let currency;
            brands.forEach((brand) => {
                if (!isCurrencyFound) {
                    const supportedBrand = (0, basic_types_1.asBrand)(brand);
                    if (!supportedBrand) {
                        return;
                    }
                    const market = get_all_markets_1.allMarkets[supportedBrand].find((m) => (0, basic_types_1.asIsoCountryCode2)(m.country.iso2) === (0, basic_types_1.asIsoCountryCode2)(iso2));
                    if (market) {
                        isCurrencyFound = true;
                        currency = market.country.currency;
                    }
                }
            });
            if (currency) {
                return currency;
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    catch (error) {
        return undefined;
    }
};
exports.getCurrencyWithISO = getCurrencyWithISO;
